import type { Dimension } from '@/entities/insight';
import { PostFilter } from '../../../../entities/post/models';

export function getNextDimension(currentDimension: Dimension | null): Dimension | null {
  switch (currentDimension) {
    case null:
      return PostFilter.Theme;
    case PostFilter.Theme:
      return PostFilter.Brand;
    case PostFilter.Brand:
      return PostFilter.Product;
    case PostFilter.Product:
      return null;
  }
}
